// import { ActivoFijoVisitanteModel } from './activoFijoVisitante.model';
// import { HisActivoFijoVisitanteModel } from './hisActivoFijoVisitante.model';

// export class ContenedorActivoFijoVisitanteModel {

//     public activoFijoVisitante:ActivoFijoVisitanteModel;
//     public hisActivoFijoVisitante:HisActivoFijoVisitanteModel;

//     constructor(activoFijoVisitante:ActivoFijoVisitanteModel
//         ,hisActivoFijoVisitante:HisActivoFijoVisitanteModel){
//             this.activoFijoVisitante=activoFijoVisitante;
//             this.hisActivoFijoVisitante=hisActivoFijoVisitante;
//     }
// }
import { ActivoFijoVisitanteModel } from './activoFijoVisitante.model';
import { HisActivoFijoVisitanteModel } from './hisActivoFijoVisitante.model';

export class ContenedorActivoFijoVisitanteModel {

    public activoFijoVisitanteDTO:ActivoFijoVisitanteModel;
    public hisActivoFijoVisitanteDTO:HisActivoFijoVisitanteModel;

    constructor(activoFijoVisitante:ActivoFijoVisitanteModel
        ,hisActivoFijoVisitante:HisActivoFijoVisitanteModel){
            this.activoFijoVisitanteDTO=activoFijoVisitante;
            this.hisActivoFijoVisitanteDTO=hisActivoFijoVisitante;
    }
}